module.exports = __webpack_public_path__ + "static/media/flag management.d702675f.svg";